import {MaxTariff, Order, PaymentMethod, PaymentMethodType, Point} from '@yandex-taxi/js-integration-api'
import {DraftAddress, DraftPayment, toPoint} from '@yandex-taxi/react-integration-api'
import {isArray, isNumber} from 'lodash'

import {MAX_ZOOM, Tariff} from '../components/consts'
import {DisplayableOrder} from '../components/utils'
import {CenterAndZoom} from './types'

export const toCardPaymentMethod = (id?: string): DraftPayment => ({
  type: PaymentMethodType.CARD,
  id,
})

export const toCashPaymentMethod = (id?: string): DraftPayment => ({
  type: PaymentMethodType.CASH,
  id,
})

export const toPaymentMethod = (id?: string): DraftPayment =>
  id === 'cash' ? toCashPaymentMethod(id) : toCardPaymentMethod(id)

export const isCardPaymentMethod = (payment: PaymentMethod): payment is PaymentMethod =>
  payment.type === PaymentMethodType.CARD

export const isPaymentMethod = (payment: PaymentMethod): payment is PaymentMethod =>
  payment.type === PaymentMethodType.CASH || isCardPaymentMethod(payment)

const tariffValues = Object.values(Tariff)
export const isTariff = (o: Order) => !!o.request?.class && tariffValues.includes(o.request.class as Tariff)
export const displayableIsTariff = (order: DisplayableOrder) => tariffValues.includes(order.tariff)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isCenterAndZoom = (value: any): value is CenterAndZoom => isArray(value.center) && isNumber(value.zoom)

export const isEqualCenterAndZoom = (
  util: typeof ymaps.util,
  containerSize: number[],
  oldParams?: CenterAndZoom | Point[],
  newParams?: CenterAndZoom | Point[],
  margin?: number,
) => {
  if (!oldParams || !newParams) {
    return false
  }
  const oldCenterAndZoom = isCenterAndZoom(oldParams)
    ? oldParams
    : util.bounds.getCenterAndZoom(oldParams, containerSize, undefined, {margin})

  const newCenterAndZoom = isCenterAndZoom(newParams)
    ? newParams
    : util.bounds.getCenterAndZoom(newParams, containerSize, undefined, {margin})

  oldCenterAndZoom.zoom = Math.min(oldCenterAndZoom.zoom, MAX_ZOOM)
  newCenterAndZoom.zoom = Math.min(newCenterAndZoom.zoom, MAX_ZOOM)

  return (
    util.math.areEqual(oldCenterAndZoom.center, newCenterAndZoom.center) &&
    oldCenterAndZoom.zoom === newCenterAndZoom.zoom
  )
}

export const getCoords = (point: DraftAddress) => {
  const geoObjectPos = point?.address?.geoObject ? toPoint(point.address.geoObject.pos) : undefined
  return geoObjectPos || point?.address?.point
}

export const sortTariffs = (availableTariffs: string[], tariffs: MaxTariff[]) =>
  [...tariffs].sort((a, b) => availableTariffs.indexOf(a.class) - availableTariffs.indexOf(b.class))
